import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { ScanLine, Radio, Box, Cpu } from "lucide-react";

const TECH_IMG =
  "https://static.prod-images.emergentagent.com/jobs/f77d8b25-2e36-4798-bc80-de674de9479a/images/ccfd17f4f9a71f2d43b336b94c84d6e808380fa6097b089f9b31f1e37a1023df.png";

const ICONS = [ScanLine, Radio, Box, Cpu];

export const Technology = () => {
  const { t } = useLang();

  return (
    <section
      id="technology"
      data-testid="technology-section"
      className="relative bg-[#0a0a0a] text-white py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-50">
        <img
          src={TECH_IMG}
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/40" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5 reveal">
            <p className="overline mb-6 text-[#D4AF37]">— {t.tech.overline}</p>
            <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              {t.tech.title}{" "}
              <span className="italic text-[#D4AF37]">
                {t.tech.title_accent}
              </span>
            </h2>
            <p className="mt-8 text-white/70 text-base md:text-lg leading-relaxed max-w-md">
              {t.tech.sub}
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-3xl overflow-hidden">
              {t.tech.items.map((item, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <div
                    key={i}
                    data-testid={`tech-card-${i}`}
                    className="reveal bg-[#0a0a0a]/90 backdrop-blur-sm p-8 md:p-10 hover:bg-[#111] transition-colors group"
                    style={{ transitionDelay: `${i * 80}ms` }}
                  >
                    <div className="flex items-center justify-between mb-10">
                      <div className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center group-hover:border-[#D4AF37] transition-colors">
                        <Icon
                          size={20}
                          strokeWidth={1.4}
                          className="text-white group-hover:text-[#D4AF37] transition-colors"
                        />
                      </div>
                      <span className="text-[10px] tracking-[0.25em] text-white/40">
                        0{i + 1}
                      </span>
                    </div>
                    <h3 className="font-display text-xl md:text-2xl tracking-tight mb-3">
                      {item.t}
                    </h3>
                    <p className="text-sm text-white/60 leading-relaxed">
                      {item.d}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
